/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectCommand } from '../../models/delete-project-command';
import { DeleteProjectCommandResult } from '../../models/delete-project-command-result';

export interface ApiProjectDeleteProjectDelete$Plain$Params {
      body?: DeleteProjectCommand
}

export function apiProjectDeleteProjectDelete$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectDeleteProjectDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectDeleteProjectDelete$Plain.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectCommandResult>;
    })
  );
}

apiProjectDeleteProjectDelete$Plain.PATH = '/api/Project/DeleteProject';
